// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.return-nav-link[data-v-2cd684b6] {
  margin-left: auto;
  margin-top: auto;
  margin-bottom: auto;
  text-transform: uppercase;
  font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
}
.arrow-wrapper[data-v-2cd684b6] {
  display: inline-block;
  overflow: hidden;
}
.arrow-wrapper .arrow[data-v-2cd684b6] {
  color: #878a96;
  font-size: 28px;
  margin-left: -20px;
  line-height: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/components/global/UtilityLink.vue","webpack://./UtilityLink.vue"],"names":[],"mappings":"AACA;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yDAAA;ACAJ;ADGA;EACI,qBAAA;EACA,gBAAA;ACDJ;ADDA;EAKQ,cAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;ACDR","sourcesContent":["\n.return-nav-link {\n    margin-left: auto;\n    margin-top: auto;\n    margin-bottom: auto;\n    text-transform: uppercase;\n    font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif;\n}\n\n.arrow-wrapper {\n    display: inline-block;\n    overflow: hidden;\n\n    .arrow {\n        color: #878a96;\n        font-size: 28px;\n        margin-left: -20px;\n        line-height: 15px;\n    }\n}\n",".return-nav-link {\n  margin-left: auto;\n  margin-top: auto;\n  margin-bottom: auto;\n  text-transform: uppercase;\n  font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif;\n}\n.arrow-wrapper {\n  display: inline-block;\n  overflow: hidden;\n}\n.arrow-wrapper .arrow {\n  color: #878a96;\n  font-size: 28px;\n  margin-left: -20px;\n  line-height: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
